import { useState } from 'react';

export default function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);

  const mainReviews = [
    {
      name: '船橋市高根台在住',
      location: '築20年マンション',
      title: 'ユニットバスリフォーム+トイレリフォーム+キッチンリフォーム',
      subtitle: '水回り3点リフォームをまとめてお願いしました',
      content: '浴室:黒カビと冬の冷えに悩んでいたタイル張りのバスルームが、断熱浴槽付き TOTOシステムバスに早変わり。湯温が長持ちして光熱費も削減。\n\nトイレ:節水型トイレ式便器を最新の 節水トイレ&温水洗浄便座に交換。水道代が目に見えて下がり、掃除もラクラク!\n\nキッチン:15年物の流し台を LIXILシステムキッチン+IHクッキングヒーター に刷新。収納力アップで調理がワクワク。\n\n工期はわずか 5日。担当の吉原さんが毎晩LINEで「今日の進捗写真」を送ってくれたり、養生の丁寧さや近隣挨拶までできる細やかさ。千葉県のリフォーム会社 湧水堂さんのプロ意識に感激しました。\n\nさらに、リフォーム補助金20万円の申請サポートまでフル対応してくれたおかげで、当初見積もりよりも安く完了!　家族全員「もっと早くやればよかった」と大歓喜です。\n\nまたなにかあれば湧水堂さんにお願いします!',
      image: 'https://static.readdy.ai/image/4671f2b3e80ac13085d7cfae87509095/c2e5e94c28add25bdb69f2cf1d81ea94.jpeg'
    },
    {
      name: 'K様',
      location: '船橋市',
      title: '想像以上の仕上がりと心配りに感動しました',
      content: '最初は不安でしたが、スタッフの方々の丁寧な対応と、7つの約束を本当に実践されている姿に感動しました。特にLINEで夜遅くに質問した時も、すぐに返信をいただけて安心できました。仕上がりも想像以上で、毎日のお風呂が楽しみになりました。',
      image: 'https://public.readdy.ai/ai/img_res/560340c4a96abe19ecb576d37e6a08ab.jpg'
    }
  ];

  const smallReviews = [
    {
      name: '船橋市 T様',
      rating: 4,
      text: '施工日程でちょっとしたトラブルもありましたがその後、無事に\n\n洗面化粧台を交換して頂きました♪\n\nこちらのワガママにも快く対応して頂き、担当者さんには感謝しております。\n暑い日の中、ご苦労さまでしたm(_ _)m\n\n金額・仕上がり共に満足しております。\nまた機会があればご相談させて頂きたいなと思います。\n今回はありがとうございました。'
    },
    {
      name: '船橋市 Y様',
      rating: 5,
      text: '丁寧にして頂きました。ありがとうございます🤗'
    },
    {
      name: '船橋市 N様',
      rating: 5,
      text: '近所で安心してお願い出来る方と出会えました!礼儀正しい若い方で、親身になって相談に乗って頂けました。納得の行く工事をして下さりありがとうございました。今後は、水まわりのことは湧水堂さんに相談させて頂きます。'
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1a2b4a] mb-6">
            お客様の声
          </h2>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 text-[#ff8c42]">
            <div className="flex text-2xl sm:text-xl">
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
              <i className="ri-star-fill"></i>
            </div>
            <span className="text-lg sm:text-xl font-bold">Google レビュー ★4.7 の実績</span>
          </div>
        </div>

        {/* Main Review */}
        <div className="bg-[#faf8f5] rounded-3xl overflow-hidden shadow-xl mb-12">
          <div className="grid lg:grid-cols-5 gap-0">
            {/* Image */}
            <div className="lg:col-span-2">
              <div className="w-full h-full min-h-[400px]">
                <img 
                  src={mainReviews[activeIndex].image}
                  alt={mainReviews[activeIndex].name}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Content */}
            <div className="lg:col-span-3 p-8 lg:p-12">
              <p className="text-sm text-gray-500 mb-4">({mainReviews[activeIndex].name})</p>
              
              <h3 className="text-2xl lg:text-3xl font-bold text-[#1a2b4a] mb-2">
                {mainReviews[activeIndex].title}
              </h3>
              {mainReviews[activeIndex].subtitle && (
                <p className="text-lg text-gray-600 mb-6">{mainReviews[activeIndex].subtitle}</p>
              )}

              <div className="mb-8">
                <div className="flex text-[#ff8c42] text-xl mb-4">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
                <div className="text-gray-700 text-base leading-relaxed whitespace-pre-line max-h-[400px] overflow-y-auto pr-4">
                  {mainReviews[activeIndex].content}
                </div>
                <p className="text-gray-600 mt-6 font-bold">
                  — {mainReviews[activeIndex].location}
                </p>
              </div>

              {/* Navigation */}
              <div className="flex gap-3">
                <button 
                  onClick={() => setActiveIndex(0)}
                  className={`w-12 h-12 rounded-full flex items-center justify-center transition-all cursor-pointer ${
                    activeIndex === 0 ? 'bg-[#1a2b4a] text-white' : 'border-2 border-gray-300 text-gray-400'
                  }`}
                >
                  <i className="ri-arrow-left-line text-xl"></i>
                </button>
                <button 
                  onClick={() => setActiveIndex(1)}
                  className={`w-12 h-12 rounded-full flex items-center justify-center transition-all cursor-pointer ${
                    activeIndex === 1 ? 'bg-[#1a2b4a] text-white' : 'border-2 border-gray-300 text-gray-400'
                  }`}
                >
                  <i className="ri-arrow-right-line text-xl"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Small Reviews */}
        <div className="grid md:grid-cols-3 gap-6">
          {smallReviews.map((review, index) => (
            <div key={index} className="bg-[#faf8f5] rounded-2xl p-8">
              <div className="flex text-[#ff8c42] text-lg mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed mb-4 whitespace-pre-line">{review.text}</p>
              <p className="text-sm text-gray-600 font-bold">— {review.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
